<template>
  <div class="wrapper">
    <div class="page page2">
      <div class="header">
        <div class="leftCA">【CA】</div>
        <table class="leftBox">
          <tr>
            <th width="45px">A</th>
            <th width="45px">B</th>
            <th width="45px">C</th>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        </table>
        <h1>裕隆集團&nbsp;&nbsp;&nbsp;裕富數位資融股份有限公司<span class="h1s">2021.04&nbsp;通路商品版</span></h1>
        <h2>購物分期付款申請暨約定書</h2>
      </div><!--header-->
      <div class="blueBox blueBox1">
        <div class="tit">基本資料</div>
        <div class="date">
          申請日期：<span class="y">108</span>年<span class="m">8</span>月<span class="d">6</span>日
        </div>
        <table class="blueTable blueTable1">
          <tr>
            <th width="45px">中&nbsp;文<br/>姓&nbsp;名</th>
            <td width="113px" class="signImg">杜捷涵<img src="sign.jpg"></td>
            <th width="48px">身分證<br/>字&nbsp;&nbsp;&nbsp;&nbsp;號</th>
            <td>C123456789</td>
          </tr>
          <tr>
            <th>出&nbsp;生<br/>日&nbsp;期</th>
            <td>
              <span class="y">106</span>年
              <span class="m">12</span>月
              <span class="d">30</span>日
            </td>
            <th>婚&nbsp;姻<br/>狀&nbsp;況</th>
            <td>
              <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled></span>已婚</div>
              <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled></span>未婚</div>
              <br/>
              <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled checked></span>子女<span
                class="nb">3</span>人
              </div>
            </td>
          </tr>
        </table><!--blueTable1-->
        <table class="blueTable blueTable2">
          <tr>
            <th width="45px">身分證<br/>初補換</th>
            <td width="163px">
              <div class="checkDiv">
                <span class="checkbox"><input type="checkbox" disabled></span>初發<br/><span class="checkbox"><input
                type="checkbox" disabled></span>補發<br/><span class="checkbox"><input type="checkbox" disabled
                                                                                     checked></span>換發
              </div>
              <div class="date2">
                <span class="y">106</span>年
                <span class="m">12</span>月
                <span class="d">30</span>日
              </div>
            </td>
            <th width="48px">發&nbsp;證<br/>地&nbsp;點</th>
            <td>基隆市</td>
          </tr>
        </table><!--blueTable2-->
        <table class="blueTable blueTable3">
          <tr>
            <th width="45px">戶&nbsp;籍<br/>電&nbsp;話</th>
            <td width="115px" class="td-phone">
              <div class="checkDiv">
                <span class="checkbox"><input type="checkbox" disabled></span>無
              </div>
              02-12345678
            </td>
            <th width="48px">住&nbsp;宅<br/>電&nbsp;話</th>
            <td class="td-phone">
              <div class="checkDiv">
                <span class="checkbox"><input type="checkbox" disabled></span>無
              </div>
              02-12345678
            </td>
          </tr>
          <tr>
            <th>行&nbsp;動<br/>電&nbsp;話</th>
            <td class="td-phone">
              <div class="checkDiv">
                <span class="checkbox"><input type="checkbox" disabled></span>無
              </div>
              0987654321
            </td>
            <th>教&nbsp;育<br/>程&nbsp;度</th>
            <td>
              <div class="checkDiv checkDiv3">
                <span class="checkbox"><input type="checkbox" disabled></span>博士
                <span class="checkbox"><input type="checkbox" disabled></span>碩士
                <span class="checkbox"><input type="checkbox" disabled></span>大學
                <span class="checkbox"><input type="checkbox" disabled></span>專科
                <span class="checkbox"><input type="checkbox" disabled checked></span>高中職
                <span class="checkbox"><input type="checkbox" disabled></span>其他
              </div>
            </td>
          </tr>
          <tr>
            <th>戶&nbsp;籍<br/>地&nbsp;址</th>
            <td colspan="3">基隆市安樂區樂一里13鄰樂一路54巷4之1號基隆市安樂區樂一里13鄰樂一路54巷4之1號</td>
          </tr>
          <tr>
            <th>住&nbsp;宅<br/>地&nbsp;址</th>
            <td colspan="3" class="td-address4">
              <div class="checkDiv checkDiv4">
                <span class="checkbox"><input type="checkbox" disabled></span>同戶籍
                <span class="checkbox"><input type="checkbox" checked disabled></span>另列如下
              </div>
              基隆市安樂區樂一里13鄰樂一路54巷4之1號基隆市安樂區樂一里13鄰樂一路54巷4之1號
            </td>
          </tr>
          <tr>
            <th>居&nbsp;住<br/>時&nbsp;間</th>
            <td>
              <div class="date3">
                <span class="y">12</span>年
                <span class="m">30</span>月
              </div>
            </td>
            <th>居&nbsp;住<br/>狀&nbsp;況</th>
            <td>
              <div class="checkDiv checkDiv5">
                <span class="checkbox"><input type="checkbox" disabled></span>本人名下
                <span class="checkbox"><input type="checkbox" disabled></span>配偶名下<br/>
                <span class="checkbox"><input type="checkbox" disabled checked></span>親友
                <span class="checkbox"><input type="checkbox" disabled></span>租賃
                <span class="checkbox"><input type="checkbox" disabled></span>宿舍
                <span class="checkbox"><input type="checkbox" disabled></span>其他
              </div>
            </td>
          </tr>
          <tr>
            <th>繳&nbsp;款<br/>方&nbsp;式</th>
            <td colspan="3" class="td-address6">
              <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled></span>簡訊條碼繳款</div>
              <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled></span>電子帳單(請填E-mail)</div>
              <br/>
              test1234567890@gmail.com
            </td>
          </tr>
          <tr>
            <th>E-mail</th>
            <td colspan="3" class="td-email">
              <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled></span>無</div>
              test1234567890@gmail.com
            </td>
          </tr>
        </table><!--blueTable3-->
      </div><!--blueBox1-->
      <div class="blueBox blueBox2">
        <div class="tit">職業資料</div>
        <div class="contact">
<!--          服務電話：(02)2702-5055&nbsp;#3<br/>-->
<!--          案件傳真：(02)2700-3559-->
        </div>
        <table class="blueTable blueTable4">
          <tr>
            <th width="48px">公&nbsp;司<br/>名&nbsp;稱</th>
            <td width="135px" class="td-com">
              <div class="checkDiv">
                <span class="checkbox"><input type="checkbox" disabled></span>無<span class="checkbox"><input
                type="checkbox" disabled></span>家管<span class="checkbox"><input type="checkbox" disabled></span>另列如下
              </div>
              股份有限公司
            </td>
            <th width="48px">公&nbsp;司<br/>電&nbsp;話</th>
            <td class="td-phone">
              <div class="checkDiv">
                <span class="checkbox"><input type="checkbox" disabled></span>無
              </div>
              02-12345678
            </td>
          </tr>
          <tr>
            <th>公&nbsp;司<br/>地&nbsp;址</th>
            <td class="td-address" colspan="3">
              <div class="checkDiv">
                <span class="checkbox"><input type="checkbox" disabled></span>無
              </div>
              基隆市安樂區樂一里13鄰樂一路54巷4之1號基隆市安樂區樂一里13鄰樂一路54巷4之1號
            </td>
          </tr>
        </table><!--blueTable4-->
        <table class="blueTable blueTable5">
          <tr>
            <th width="48px">職稱</th>
            <td width="90px">工程師</td>
            <th width="35px">年資</th>
            <td width="73px">
              <div class="date4">
                <span class="y">2</span>年
                <span class="m">3</span>月
              </div>
            </td>
            <th width="33px">月薪</th>
            <td><span class="salary">100,000</span>元</td>
          </tr>
        </table><!--blueTable5-->
        <div class="blueBox blueBox3">
          <div class="tit">銀行資料</div>
          <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled=""></span>沒辦過卡</div>
          <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled=""></span>無卡自停</div>
          <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled=""></span>協商繳款中</div>
          <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled=""></span>其他：
            <div class="others">內容內容內最多十個字超過不顯示</div>
          </div>
          <table class="blueTable blueTable6">
            <tr>
              <th width="48px">發&nbsp;卡<br/>銀&nbsp;行</th>
              <td width="125px">台新銀行</td>
              <th width="50px">有&nbsp;效<br/>日&nbsp;期</th>
              <td>
                <div class="date5">
                  <span class="m">05</span>月
                  <span class="y">20</span>年
                </div>
              </td>
            </tr>
            <tr>
              <th>卡號</th>
              <td colspan="3" class="cardNb">1234-5678-1234-5678<span class="ps">(請填寫本人正卡資料)</span></td>
            </tr>
          </table><!--blueTable6-->
        </div><!--blueBox3-->
        <div class="blueBox blueBox4">
          <div class="tit">聯絡人資料</div>
          <span class="titps">(請留一位與您不同居所的親屬，若無住家電話請留兩位聯絡人)</span>
          <table class="blueTable blueTable7">
            <tr>
              <th width="48px">中&nbsp;文<br/>姓&nbsp;名</th>
              <td width="110px">杜捷涵</td>
              <th width="30px">關係</th>
              <td width="35px" class="text_c">母女</td>
              <th width="50px">行&nbsp;動<br/>電&nbsp;話</th>
              <td class="td-phone">
                <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled=""></span>無</div>
                0987654321
              </td>
            </tr>
          </table><!--blueTable7-->
          <table class="blueTable blueTable8">
            <tr>
              <th width="48px">住&nbsp;宅<br/>電&nbsp;話</th>
              <td width="140px" class="td-phone">
                <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled=""></span>無</div>
                07-1234567
              </td>
              <th width="35px">公&nbsp;司<br/>電&nbsp;話</th>
              <td class="td-phone">
                <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled=""></span>無</div>
                07-1234567
              </td>
            </tr>
          </table><!--blueTable8-->
          <table class="blueTable blueTable9">
            <tr>
              <th width="48px">中&nbsp;文<br/>姓&nbsp;名</th>
              <td width="110px">杜捷涵</td>
              <th width="30px">關係</th>
              <td width="35px" class="text_c">母女</td>
              <th width="50px">行&nbsp;動<br/>電&nbsp;話</th>
              <td class="td-phone">
                <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled=""></span>無</div>
                0987654321
              </td>
            </tr>
          </table><!--blueTable9-->
          <table class="blueTable blueTable10">
            <tr>
              <th width="48px">住&nbsp;宅<br/>電&nbsp;話</th>
              <td width="140px" class="td-phone">
                <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled=""></span>無</div>
                07-1234567
              </td>
              <th width="35px">公&nbsp;司<br/>電&nbsp;話</th>
              <td class="td-phone">
                07-1234567
              </td>
            </tr>
          </table><!--blueTable10-->
        </div><!--blueBox4-->
      </div><!--blueBox2-->
      <div class="redBox">
        <div class="ps">※以下欄位資料為：
          <div class="checkDiv">1.<span class="checkbox"><input type="checkbox" disabled=""></span>連帶保證人(需附保證人身分證正反面影本及簽名)
          </div>
          <div class="checkDiv">2.<span class="checkbox"><input type="checkbox" disabled=""></span>配偶資料僅供參考</div>
          <div class="checkDiv">3.<span class="checkbox"><input type="checkbox" disabled=""></span>法定代理人(須於法代欄位簽名)</div>
          <div class="checkDiv">4.<span class="checkbox"><input type="checkbox" disabled=""></span>商品實際使用人</div>
        </div>
        <table class="redTable">
          <tr>
            <th width="48px">姓&nbsp;名</th>
            <td width="160px">陳先生</td>
            <th width="55px">關&nbsp;係</th>
            <td width="83px">父女</td>
            <th width="48px">身分證<br/>字&nbsp;&nbsp;號</th>
            <td width="153px">A123456789</td>
            <th width="48px">出&nbsp;生<br/>日&nbsp;期</th>
            <td>
              <div class="date6">
                <span class="y">75</span>年
                <span class="m">12</span>月
                <span class="d">22</span>日
              </div>
            </td>
          </tr>
          <tr>
            <th>身分證<br/>初補換</th>
            <td>
              <div class="checkDiv">
                <span class="checkbox"><input type="checkbox" disabled></span>初發<br/><span class="checkbox"><input
                type="checkbox" disabled></span>補發<br/><span class="checkbox"><input type="checkbox" disabled
                                                                                     checked></span>換發
              </div>
              <div class="date7">
                <span class="y">106</span>年
                <span class="m">12</span>月
                <span class="d">30</span>日
              </div>
            </td>
            <th>發&nbsp;證<br/>地&nbsp;點</th>
            <td>基隆市</td>
            <th>住&nbsp;家<br/>電&nbsp;話</th>
            <td class="td-phone">
              <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled=""></span>無</div>
              07-1234567
            </td>
            <th>行&nbsp;動<br/>電&nbsp;話</th>
            <td class="td-phone">
              <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled=""></span>無</div>
              0987654321
            </td>
          </tr>
          <tr>
            <th>公&nbsp;司<br/>名&nbsp;稱</th>
            <td colspan="3">台灣有限公司</td>
            <th>職&nbsp;稱</th>
            <td class="td-phone">
              <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled=""></span>無</div>
              工程師
            </td>
            <th>公&nbsp;司<br/>電&nbsp;話</th>
            <td class="td-phone">
              <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled=""></span>無</div>
              07-1234567
              <span class="ext">分機<span>123</span></span>
            </td>
          </tr>
        </table><!--redTable-->
      </div><!--redBox-->
      <div class="yBox">
        <div class="ps">
          ※以下欄位由經銷商或債權讓與人填寫並經申請人及其連帶保證人確認無誤&nbsp;※此案件為:「
          <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled=""></span>新件</div>
          <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled=""></span>補保人</div>
          <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled=""></span>補資料</div>
          」&nbsp;「
          <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled=""></span>零利率</div>
          <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled=""></span>低利率</div>
          」「
          <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled=""></span>ㄧ般件</div>
          <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled=""></span>保密件</div>
          」
        </div>
        <div class="tit">經&nbsp;&nbsp;銷&nbsp;&nbsp;商&nbsp;&nbsp;填&nbsp;&nbsp;寫&nbsp;&nbsp;欄</div>
        <table class="yTable1">
          <tr class="yTr">
            <th width="20px" rowspan="2">分期內容</th>
            <th width="110px">商品名稱</th>
            <th width="73px" class="psTh1">頭款<span>(訂金)</span></th>
            <th width="65px">商品總價</th>
            <th width="155px" class="psTh2">辦理分期金額<span>(商品總價-已付頭款)</span></th>
            <th width="45px">期數</th>
            <th width="130px" class="psTh3">每期應繳金額<span>(期付款)</span></th>
            <th class="psTh4">分期總額<span>(期數X期付金額)</span></th>
          </tr>
          <tr>
            <td>機車</td>
            <td>1,000</td>
            <td>150,000</td>
            <td>150,000</td>
            <td>24</td>
            <td>7635</td>
            <td>183,240</td>
          </tr>
        </table><!--yTable1-->
        <table class="yTable2">
          <tr>
            <th width="70px">
              <span class="th1">經銷商或<br/>債權讓與人名稱<br/>(約定受款方)</span></th>
            <td width="133px">名稱</td>
            <th width="65px">
              <span class="th2">經銷商或<br/>債權讓與人<br/>電話</span>
            </th>
            <td width="105px" class="td-phone">
              <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled=""></span>無電話請打手機聯絡</div>
              0987654321
            </td>
            <th width="50px">
              <span class="th3">經銷商或<br/>債權讓與人<br/>傳真</span>
            </th>
            <td width="110px" class="td-phone">
              <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled=""></span>無傳真請電話通知</div>
              0987654321
            </td>
            <th rowspan="3" class="sign1">
              <span class="bg"></span>
              <span class="txt">(請蓋公司大小章或發票章)</span>
              <span class="ps">※債權轉讓確認章<br/>※遲延利息及委約金之請求權同意一併讓與受讓人</span>
            </th>
          </tr>
          <tr>
            <th>經辦店名稱</th>
            <td class="td-phone">
              <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled=""></span>同經銷商或債權讓與人</div>
              名稱
            </td>
            <th>經辦店<br/>電&nbsp;&nbsp;話</th>
            <td class="td-phone">
              <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled=""></span>無電話請打手機聯絡</div>
              0987654321
            </td>
            <th>經辦人<br/>手&nbsp;&nbsp;機</th>
            <td>0987654321</td>
          </tr>
          <tr>
            <td colspan="6" class="td-phone td-phone2">

              <div class="checkDiv checkDiv2">
                經銷商備註欄：<br/>
                <span class="checkbox"><input type="checkbox" disabled=""></span>熟客&nbsp;
                <span class="checkbox"><input type="checkbox" disabled=""></span>過路客&nbsp;
                <span class="checkbox"><input type="checkbox" disabled=""></span>指定照會時間：<span class="m">12</span>月<span
                class="d">31</span>日<span class="t">上</span>午<span class="h">12</span>點<span class="min">30</span>分
              </div>
              <span class="ps2">備註備註最多25個中文字</span>
              <div class="sign2">
                經辦人簽名
                <span class="bg">王先生</span>
                <span class="txt">本人證實申請人及連帶保證人身分正確並親自簽章無誤</span>
              </div>
            </td>
          </tr>
        </table><!--yTable2-->
      </div><!--yBox-->
      <div class="gTit">約定事項</div>
      <div class="gContent">
        <ul class="gBoxCon">
          申請人（以下簡稱甲方）及其連帶保證人、經銷商或債權讓與人（以下簡稱乙方）及債權受讓人裕富數位資融（股）公司（以下簡稱裕富公司）三方同意訂定本購物分期付款申請暨約定書（以下簡稱本約定書），<span
          class="red">其個別商議及特別授權之約定事項如下：</span><br/>
          <li>
            甲方及其連帶保證人同意裕富公司得將甲方及其連帶保證人與裕富公司往來本契約之相關資料（包括但不限於基本資料、信用資料、財務資料等），提供予財團法人金融聯合徵信中心及中華徵信所企業股份有限公司依其設立目的、章程及相關法令規定，蒐集、處理及利用甲方及其連帶保證人之資料，並已暸解及同意裕富公司及財團法人金融聯合徵信中心及中華徵信所企業股份有限公司依個人資料保護法規定所告知之事項。財團法人金融聯合徵信中心及中華徵信所企業股份有限公司依其設立目的、章程及相關法令規定，得將本人資料提供與其參與徵信資料交換及利用之會員、融資租賃業、金融目的事業主管機關及其他依法令得蒐集、處理及利用資料之人。甲方及其連帶保證人確認已受個人資料保護法第三條、第八條及第九條告知且留存本約定書繕本，得憑之主張相關權利。
          </li>
          <li>
            甲方及其連帶保證人同意裕富公司得於履行契約及商品推廣、市場調查、數據分析之目的範圍內，依個人資料保護法相關規定以電腦蒐集、處理、利用甲方及其連帶保證人提供之前述基本資料（不包括財團法人金融聯合徵信中心及中華徵信所企業股份有限公司查詢之信用資料），並向相關之個人、機關、法人等查詢該等資料及往來紀錄，亦同意裕富公司得將前述往來之資料，提供予（一）受讓（或擬受讓）裕富公司債權之債權人，（二）受裕富公司委任代為處理事務之人或與裕富公司有簽約之委外合作廠商，（三）裕富公司之分公司，（四）裕隆汽車製造（股）公司及其相關企業／裕融企業及其關係企業，（五）財團法人金融聯合徵信中心，（六）逾期催收之受託公司（限甲方及其連帶保證人違約時）。但甲方及其連帶保證人得隨時要求停止對其相關資料交互運用。<span
            class="red">申請人就本項約定：<div class="checkDiv"><span class="checkbox"><input type="checkbox" checked
                                                                                     disabled></span>同意</div><div
            class="checkDiv"><span class="checkbox"><input type="checkbox" disabled></span>不同意</div>（若未勾選視為不同意）；連帶保證人就本項約定：<div
            class="checkDiv"><span class="checkbox"><input type="checkbox" checked disabled></span>同意</div><div
            class="checkDiv"><span class="checkbox"><input type="checkbox" disabled></span>不同意</div>（若未勾選視為不同意）</span>
          </li>
          <li>
            甲方及其連帶保證人已受說明／告知本約定書重要內容及相關權利義務，並已充分暸解本約定書之重要內容及相關權利義務，且同意乙方或裕富公司得修正本約定書（共二頁）所填資料，並同意申請時所提供之資料及本約定書正本不予退還。
          </li>
          <li>甲方及其連帶保證人已攜回本約定書審閱，並經給予五日以上之期間詳閱並充分了解本契約之全部條款後簽訂本約定書。</li>
          <li>
            甲方及其連帶保證人於簽約時已充分暸解並同意，乙方將請求支付分期價款之權利及依本約定書約定所得享受之其他一切權利及利益（含延遲利息及違約金）讓與裕富公司，裕富公司並依約付款予乙方或撥入「指示付款同意暨約定書」所指定之帳戶以為收買應收帳款之債權。甲方及其連帶保證人並於裕富公司依約為上述撥付款項時即為知悉債權讓與事實，並應依約繳款予裕富公司。
          </li>
          <li>分期價金還款方式與內容：本分期依經銷商填寫欄內容自撥款日次月起每月一期，依年金計法計算，按月平均攤還本息予裕富公司。</li>
          <li>甲方申辦之機車分期付款業務，車牌號碼：<span class="txtBox">888-CCC</span>；甲方同意將前述車輛車牌領牌登記於二等親屬（姓名：<span
            class="txtBox">陳先生</span>、身分證字號：<span class="txtBox">A123456789</span>、與甲方關係為
            <div class="checkDiv"><span class="checkbox"><input type="checkbox" checked disabled></span>本人之父／母</div>
            <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled></span>子／女</div>
            <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled></span>兄／弟</div>
            <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled></span>姊／妹</div>
            <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled></span>祖父／母</div>
            <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled></span>外祖父／母</div>
            <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled></span>孫／孫女／外孫／外孫女</div>
            ）之名下（並檢附證明），全部分期付款概由甲方負責。
          </li>
          <li>
            甲方及其連帶保證人同意特別授權如下：（一）甲方及其連帶保證人同意裕富公司將款項撥入甲方與乙方所指定之帳戶時，授權裕富公司及其指定人填載本票發票日（即撥款日）及本票金額（即分期總額）、付款地，甲方及其連帶保證人絕無異議。（二）甲方及其連帶保證人倘有違反本約定書任一條款或遲延繳納分期款項時，甲方及其連帶保證人均授權裕富公司及其指定人得不經通知逕行填載本票到期日，並主張票據權利。（三）此本票供為分期付款買賣之分期款項總項憑證，俟分期付款完全清償完畢時，本票自動失效，但如有一期未付，發票人就全部本票債務負責清償。<br/><span
            class="red">※***甲方、甲方之法定代理人及甲方之連帶保證人確認已充分詳閱及了解並同意本約定書及其個別商議及特別授權之約定事項各款內容並確認簽章：</span></li>
        </ul><!--gBoxCon-->
      </div><!--約定事項gContent-->
      <div class="signBlue">
        甲方<span class="s">(申請人)</span><br/>
        簽&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名
        <span class="box"></span>
      </div>
      <div class="signRed">
        甲&nbsp;方&nbsp;連&nbsp;帶<br/>
        保證人簽章
        <span class="box"></span>
      </div>
      <div class="signGreen">
        甲&nbsp;方&nbsp;法&nbsp;定<br/>
        代理人簽名
        <span class="box"></span>
        <span class="box2"></span>
      </div>
      <div class="dot"><span>(續下頁)</span></div>
      <div class="bottomTit">&#9826本票</div>
      <div class="bottomCon">
        憑票於中華民國<span class="d1">108</span>年<span class="d1">12</span>月<span class="d1">31</span>日無條件支付裕富數位資融股份有限公司<br/>
        新台幣<span class="money">壹</span>拾<span class="money">壹</span>萬<span class="money">壹</span>仟<span
        class="money">壹</span>佰<span class="money">壹</span>拾<span class="money">壹</span>元整<span class="ps3">(本票金額可填大寫或阿拉伯數字，二擇一)</span>
        <span class="ps1">此本票免除做成拒絕證書及票據法第八十九條之通知義務，利息自到期日迄清償日止按年息百分之十六計付，發票人授權持票人得填載到期日。</span>
        <br/>
        付款地：高雄<br/>
        中華民國<span class="d2">108</span>年<span class="d2">12</span>月<span class="d2">31</span>日1.發票人：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
        class="box1"></span>2.發票人：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
        class="box2"></span>3.發票人：<span class="box3"></span>
        <div class="signAll">法定代理人：<span class="box4"></span><span class="box5"></span></div>
        <span class="ps2"></span>

      </div><!--bottomCon-->
    </div><!--page2-->

  </div><!--wrapper-->
</template>

<script>
  export default {
    name: 'CAProductView'
  };
</script>

<style scoped style="../../assets/css/ca_product_view.css">

</style>



// WEBPACK FOOTER //
// src/pages/web/CAProductView.vue